import { useShallow } from 'zustand/react/shallow'
import { useAuthStore } from './authStore'

export function useAuth() {
  return useAuthStore(useShallow((s) => ({
    status: s.status,
    user: s.user,
    accessToken: s.accessToken,
    expiresAtMs: s.expiresAtMs,
    error: s.error,
  })))
}

export function useAccessToken(): string | null {
  return useAuthStore((s) => s.accessToken)
}

export function useHasPermission(key: string): boolean {
  return useAuthStore((s) => s.user?.permissions?.includes(key) ?? false)
}

export function useIsAdmin(): boolean {
  return useHasPermission('user:manage')
}
